// Тексты промо-страницы /promo/reviews. Серверная копия для поисковиков и ИИ-ответов лежит в
// backend/app/services/promo_pages.py: правите здесь — правьте и там.

export const PROMO_CODE = 'REVIEWS';
export const PROMO_UTM = { utm_source: 'promo', utm_medium: 'landing', utm_campaign: 'reviews' };
export const PAGE_URL = 'https://seller.anylex.ru/promo/reviews';
// Доля оборота, которую берёт подписка Ozon: меняется здесь и в promo_pages.py
export const OZON_SUBSCRIPTION_SHARE = '1,3%';
export const OZON_SUBSCRIPTION_SHARE_NUM = 0.013;
// Бонус промокода при регистрации: задаётся в админке (промокод REVIEWS), здесь только текст страницы
export const PROMO_BONUS = '5 000 ₽';
// Ориентир для калькулятора: ответ ИИ ~3 900 входных и ~80 выходных токенов, себестоимость × наценка 2 (см. feedback_llm.price_from_cost)
export const AI_REPLY_PRICE_RUB = 0.35;
export const BASE_PLAN_FALLBACK_RUB = 1999;
// Доля отзывов без текста: в реальном кабинете ≈50%. Публичный ответ на них невозможен, ИИ не вызывается
export const NO_TEXT_REVIEWS_SHARE = 0.5;
// Сколько минут сотрудник тратит на один ответ (допущение для вкладки «Сотрудник или сервис»)
export const STAFF_MINUTES_PER_REPLY = 4;
export const STAFF_HOURLY_RUB = 450;
// Доля ответов, где нужен ИИ (остальное закрывают правила и шаблоны): допущение для калькулятора
export const AI_REPLIES_SHARE = 0.5;

export const HERO = {
    eyebrow: 'Отзывы · вопросы · чаты · техподдержка Ozon',
    title: `Полная и контролируемая автоматизация отзывов, вопросов, чатов и техподдержки Ozon`,
    lead: 'Вы платите только за действия, которые мы реально выполнили, и одобряете всё, что уходит покупателю.',
    answer: `Энилекс собирает отзывы, вопросы и чаты из вашего кабинета Ozon, сам разбирает их и готовит ответы по базе знаний магазина. Отзывы доступны на бесплатном тарифе, вопросы, чаты и техподдержка Ozon — с базового.`,
    facts: ['Отзывы — бесплатный тариф', 'Чаты, вопросы, техподдержка — с базового', 'Оплата только за действия'],
};

export const PROBLEMS = [
    { title: 'Отзывы копятся', text: 'Каждый без ответа — потерянный рейтинг и доверие покупателя в карточке.' },
    { title: 'Чат ждёт', text: 'Ozon ценит скорость первого ответа, а сообщения приходят в любое время.' },
    { title: 'Подписка ест оборот', text: `Решение Ozon берёт ${OZON_SUBSCRIPTION_SHARE} от оборота, даже когда отвечать нужно на пару десятков обращений.` },
];

export const STEPS = [
    { n: '1', title: 'Подключаете кабинет', text: 'Ставите локальный агент Энилекс на компьютер. Он читает отзывы, вопросы и чаты из обычного интерфейса кабинета Ozon.' },
    { n: '2', title: 'Мы разбираем поток', text: 'Простое закрывают правила и шаблоны, без дорогой языковой модели. Сложное и рискованное уходит человеку.' },
    { n: '3', title: 'Готовим ответ', text: 'ИИ пишет черновик только по фактам из базы знаний вашего товара. Нет факта — нет ответа, обращение уходит вам.' },
    { n: '4', title: 'Вы решаете', text: 'Для каждого типа обращений выбираете режим: выключено, черновик на одобрение или автоотправка.' },
];

export const DIRECTIONS = [
    {
        id: 'reviews', icon: '⭐', title: 'Отзывы', plan: 'free',
        text: 'Очередь отзывов, черновики ответов, шаблоны, фильтр по оценкам 1–5★, анализ по товарам и калькулятор: сколько отзывов нужно до целевого рейтинга.',
        points: ['Простые отзывы закрывают шаблоны: бесплатно', 'Негатив и риск идут человеку', 'Анализ тем и динамики рейтинга по товарам'],
    },
    {
        id: 'questions', icon: '❓', title: 'Вопросы', plan: 'base',
        text: 'Ответ берётся из базы знаний магазина: характеристики, совместимость, комплектация. Вопросы-претензии («чем отличается от прежней партии») уходят человеку.',
        points: ['Факты из карточки и вашей базы знаний', 'Нет факта: ответ не публикуется', 'Пробелы базы знаний видны списком'],
    },
    {
        id: 'chats', icon: '💬', title: 'Чаты с покупателями', plan: 'base',
        text: 'Новые чаты опрашиваются каждые несколько минут. Служебные чаты Ozon отсеиваются, остальные попадают в общую очередь вместе с отзывами и вопросами.',
        points: ['Быстрый опрос новых чатов', 'Служебные чаты Ozon пропускаются', 'Одна очередь на все каналы'],
    },
    {
        id: 'support', icon: '🎧', title: 'Техподдержка Ozon', plan: 'base',
        text: 'Робот ведёт переписку с поддержкой по вашему заданию: читает ответы, пишет сам, спрашивает вас, когда не хватает данных, и может завести новое обращение.',
        points: ['Задание: чего нужно добиться', 'Лимит сообщений в день', 'Вопрос вам, если не хватает данных'],
    },
];

export const CONTROL = [
    { title: 'Три режима на каждый тип', text: 'Выключено, черновик на одобрение или автоотправка. Разные режимы для шаблонов, ИИ и обращений «нужен человек».' },
    { title: 'Стоп-слова', text: 'Аллергия, ожог, прокуратура, суд, Роспотребнадзор и другие темы риска всегда идут человеку.' },
    { title: 'Проверка перед отправкой', text: 'Ответ не уйдёт с обещанием компенсации, просьбой изменить отзыв, ссылкой, телефоном или упоминанием другой площадки.' },
    { title: 'Только факты магазина', text: 'ИИ видит базу знаний товара. Выдумывать характеристики ему нечем.' },
    { title: 'Персональные данные закрыты', text: 'Имена, телефоны и номера заказов заменяются маркерами до любого внешнего вызова.' },
    { title: 'Журнал и лимиты', text: 'Расход по дням, лимит ИИ-черновиков в сутки, история отправок и причины отказов.' },
];

export const PRICING = {
    title: 'Платите за действия, а не за доступ',
    lead: 'Сбор, очередь, база знаний, шаблонные ответы и калькулятор рейтинга входят в тариф. ИИ списывает деньги с баланса только за выполненную работу.',
    items: [
        { title: 'Шаблонный ответ', text: 'Бесплатно: языковая модель не используется.' },
        { title: 'Ответ ИИ', text: 'По фактическому расходу токенов. Каждое списание видно в биллинге раздела.' },
        { title: 'Первичный разбор', text: 'Не дорогой языковой моделью, поэтому вы не платите за сортировку потока.' },
    ],
    note: 'Цена тарифов — из живого каталога. Подключение подписки Ozon не требуется.',
};

export const COMPARE = {
    columns: ['', 'Подписка Ozon', 'Энилекс'],
    rows: [
        ['Как платите', `Доля от оборота (${OZON_SUBSCRIPTION_SHARE})`, 'За фактические действия'],
        ['Отзывы', 'Входят в подписку', 'Да, на бесплатном тарифе'],
        ['Чаты с покупателями', 'Отдельно, в Premium', 'В общей очереди, с базового тарифа'],
        ['Техподдержка Ozon', 'Не входит в подписку на отзывы', 'Робот ведёт переписку по заданию'],
    ],
};

export const ANALYTICS = {
    title: 'Анализ отзывов: как меняется рейтинг и почему',
    lead: 'Не только ответы, но и картина целиком: по магазину и по каждому артикулу, с динамикой и сравнением периодов.',
    points: [
        { title: 'Динамика по неделям', text: 'Рейтинг и число отзывов по неделям: видно, когда просело и после чего.' },
        { title: 'Сравнение периодов', text: 'Выбранный период против предыдущего: что выросло, что упало и на сколько.' },
        { title: 'Магазин и каждый артикул', text: 'Распределение оценок 1–5★ и тренд по всему кабинету и по каждому товару отдельно.' },
        { title: 'Причины негатива', text: 'Негативные отзывы по товару собраны вместе, ИИ-сводка выделяет повторяющиеся темы.' },
        { title: 'Калькулятор рейтинга', text: 'Сколько отзывов нужно до целевой оценки по конкретному артикулу.' },
        { title: 'Выгрузка', text: 'База отзывов и вопросов в JSONL и CSV для своих отчётов и других ИИ.' },
    ],
};

export const START_STEPS = [
    { n: '1', title: 'Зарегистрируйтесь', text: `Промокод ${PROMO_CODE} даёт ${PROMO_BONUS} новым пользователям при регистрации.` },
    { n: '2', title: 'Подключите кабинет', text: 'Установите локальный агент Энилекс и войдите в кабинет Ozon: он будет читать обращения и отправлять одобренные ответы.' },
    { n: '3', title: 'Включите режимы', text: 'Выберите для отзывов, вопросов и чатов: выключено, черновик на одобрение или автоотправка.' },
];

export const FAQ = [
    { q: 'Нужна ли подписка Ozon «Управление отзывами»?', a: 'Нет. Энилекс работает через обычный интерфейс кабинета и не подключает платные услуги Ozon.' },
    { q: 'Сколько стоит автоматизация отзывов?', a: 'Работа с отзывами доступна на бесплатном тарифе. Шаблонные ответы бесплатны, ИИ списывает деньги по фактическому расходу токенов.' },
    { q: 'Какие тарифы нужны для вопросов, чатов и техподдержки?', a: 'Вопросы, чаты с покупателями и техподдержка Ozon доступны с базового тарифа.' },
    { q: 'ИИ может написать лишнее покупателю?', a: 'Ответ строится только по базе знаний товара и проходит проверку: обещания компенсации, ссылки, телефоны и просьбы изменить отзыв блокируются. Рискованные темы уходят человеку.' },
    { q: 'Можно ли оставить ручное одобрение?', a: 'Да. Для каждого типа обращений выбирается режим: выключено, черновик на одобрение или автоотправка.' },
    { q: 'Что с персональными данными покупателей?', a: 'До внешних вызовов имена, телефоны, e-mail и номера заказов заменяются маркерами. Исходный текст в базе не хранится.' },
    { q: 'Что даёт промокод REVIEWS?', a: `Промокод ${PROMO_CODE} даёт ${PROMO_BONUS} новым пользователям при регистрации.` },
    { q: 'Как быстро начать?', a: 'Зарегистрируйтесь с промокодом, подключите кабинет Ozon через локальный агент и включите нужные типы обращений.' },
];

export const SEO = {
    title: 'Автоматизация отзывов, вопросов, чатов и техподдержки Ozon — Энилекс',
    description: `Автоматизация отзывов, вопросов, чатов и техподдержки Ozon без подписки за ${OZON_SUBSCRIPTION_SHARE} от оборота. Отзывы на бесплатном тарифе, оплата только за действия, ответы по базе знаний магазина.`,
};
